import { ScreenLoader } from '@/components'
import { SignInScreen } from '@/screens/SignInScreen'

// eslint-disable-next-line react/display-name
export default () => <ScreenLoader ScreenComponent={SignInScreen} />
